import useSWR from 'swr';

import { stepNames } from '../pages/onboarding/constants';
import { FIRST_STEPS_URL } from '../utils/api-urls';
import fetcher from '../utils/fetcher';

const SETUPS_STEPS = [stepNames.LOGISTIC_ADDRESS, stepNames.BANK_ACCOUNT, stepNames.SUBSCRIPTION];

const useFirstSteps = (url = FIRST_STEPS_URL) => {
  const { data, error } = useSWR(url, fetcher);

  const completedSteps = data?.completed_steps || [];
  return {
    completedSteps,
    hasError: error,
    isAllStepsCompleted:
      completedSteps.includes(stepNames.FIRST_STEPS_COMPLETED) ||
      SETUPS_STEPS.every((step) => completedSteps.includes(step)),
    isLoading: !data,
    subscription: data?.subscription,
  };
};

export default useFirstSteps;
